module.exports = __webpack_public_path__ + "img/dowin.8b8e0f05.jpg";